
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";

const AboutSection = () => {
  return (
    <section className="section-padding bg-kaija-light">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 items-start">
          <div className="md:col-span-4 md:sticky md:top-24">
            <div className="bg-white p-2 rounded-lg shadow-sm">
              <AspectRatio ratio={4/5} className="overflow-hidden rounded-md">
                <img 
                  src="/images/received_251291397735991-01.jpeg" 
                  alt="Kaija Alliksaar" 
                  className="w-full h-full object-cover"
                />
              </AspectRatio>
            </div>
          </div>
          
          <div className="md:col-span-8">
            <h2 className="text-2xl md:text-3xl font-medium mb-4">Minust</h2>
            <div className="w-16 h-1 bg-kaija-slate/60 rounded-full mb-6"></div>
            
            <p className="text-gray-700 mb-6">
              Coaching on võimas tööriist, mis toetab sind nii isikliku kui ka professionaalse kasvu teel. Minu unikaalne lähenemine ühendab traditsioonilised coachingutehnikad somaatiliste praktikate ja trauma teadlikkusega. Vastavalt vajadusele kaasan ka hüpnoteraapia.
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              <div className="bg-white p-5 rounded-lg shadow-sm">
                <h3 className="text-lg font-medium mb-2">Sügav eneseteadvus ja kasv</h3>
                <p className="text-gray-700">
                  Õpime tundma sinu sügavalt juurdunud mõttemustreid ja käitumisviise, et muuta need toetavaks.
                </p>
              </div>
              
              <div className="bg-white p-5 rounded-lg shadow-sm">
                <h3 className="text-lg font-medium mb-2">Kehateadlikkus ja tasakaal</h3>
                <p className="text-gray-700">
                  Õpid tundma oma närvisüsteemi ja keha reaktsioone, saavutades suurema tasakaalu ja rahulolu elus.
                </p>
              </div>
              
              <div className="bg-white p-5 rounded-lg shadow-sm md:col-span-2">
                <h3 className="text-lg font-medium mb-2">Püsivad tulemused</h3>
                <p className="text-gray-700">
                  Koos loome strateegiad, mis aitavad sul saavutada isiklikke ja tööalaseid eesmärke.
                </p>
              </div>
            </div>
            
            <Button asChild className="bg-kaija-slate hover:bg-opacity-90 text-white">
              <Link to="/about">Loe rohkem minust</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
